import {SprintsRepository} from '../persistence/sprints_repository';
import {SprintApi} from '../network/sprint_api';

export class SprintDeleter {
    constructor(private sprintRepository: SprintsRepository, private sprintApi: SprintApi) {}

    public async destroy(sprintId: number) {
        const sprint = this.sprintRepository.find(sprintId);
        if (sprint !== null) {
            try {
                this.sprintRepository.destroy(sprintId);

                await this.sprintApi.destroy(sprintId);
            } catch (e) {
                //On error restore
                this.sprintRepository.store(sprint);
            }
        }
    }

    async destroyMany(sprintIds: number[]) {
        const sprints = this.sprintRepository.findMany(sprintIds);
        try {
            this.sprintRepository.destroyMany(sprintIds);

            await this.sprintApi.destroyMany(sprintIds);
        } catch (e) {
            //On error restore
            this.sprintRepository.storeMany(sprints);
        }
    }
}
